export default __webpack_public_path__ + "static/media/compilation.8e0d5e8a.svg";